var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,333.3c0-18.4,14.9-33.3,33.3-33.3h0.3c18.4,0,33.3,14.9,33.3,33.3c0,18.4-14.9,33.3-33.3,33.3h-0.3 C248.3,366.7,233.3,351.7,233.3,333.3z M366.7,333.3c0-18.4,14.9-33.3,33.3-33.3h0.3c18.4,0,33.3,14.9,33.3,33.3 c0,18.4-14.9,33.3-33.3,33.3H400C381.6,366.7,366.7,351.7,366.7,333.3z M533.3,300c-18.4,0-33.3,14.9-33.3,33.3 c0,18.4,14.9,33.3,33.3,33.3h0.3c18.4,0,33.3-14.9,33.3-33.3c0-18.4-14.9-33.3-33.3-33.3H533.3z M231.1,66.7c0.7,0,1.5,0,2.2,0 h335.5c29.5,0,55,0,75.4,2.7C666.1,72.3,687.1,79,704,96c17,17,23.6,37.9,26.6,59.8c2.7,20.4,2.7,45.8,2.7,75.4v204.4 c0,29.6,0,55-2.7,75.4c-2.9,21.9-9.6,42.8-26.6,59.8c-17,17-37.9,23.6-59.8,26.6c-20.4,2.7-45.9,2.7-75.4,2.7H466.7 c-3.8,0-7.5,1.2-10.5,3.4L309.2,710.3c-31.6,23-75.9,0.4-75.9-38.6V600c-25.8,0-52,0.7-77.6-2.7c-21.9-2.9-42.8-9.6-59.8-26.6 c-17-17-23.6-37.9-26.6-59.8c-2.7-20.4-2.7-45.8-2.7-75.4V233.3c0-0.7,0-1.5,0-2.2c0-29.5,0-55,2.7-75.4C72.3,133.9,79,112.9,96,96 c17-17,37.9-23.6,59.8-26.6C176.1,66.7,201.6,66.7,231.1,66.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.f28d17faf408c4af3db0d788d3ddce28.svg";
export { ForwardRef as ReactComponent };